import { BriefDocumentInfo } from '@app/core/models/probate-document.model';

export function getGroupedDocumentsToFileList(
  groupedDocuments: BriefDocumentInfo[] | undefined,
) {
  if (!groupedDocuments) return [];
  return groupedDocuments.map(({ file, filename, id }) => ({
    url: file,
    filename,
    id: id.toString(),
  }));
}
